<div class="header-captar">
  <div class="imagen-header">
    <img  *ngIf="!isNoesys" src="../../../assets/img/logo.png" style="width:57px;height:55px">
    <img  *ngIf="isNoesys" src="../../../assets/img/noesys-login.png" style="width:87px;height:55px">
  </div>
  <div class="name-header">{{'Panel de Administración | ' + (this.circuito ? this.circuito.nombre : '')}}</div>
  <button class="logout-button" (click)="logout()">LOGOUT</button>
</div>
<div class="options-panel">
  <button *ngFor="let option of options; let i = index" (click)="goView(option.url)" class="option"
          [ngClass]="(i == active) ? 'option-active':'option-inactive'">
    <img [src]="option.icon" class="icon-option"> {{option.name}}
  </button>
</div>




// WEBPACK FOOTER //
// ./src/app/admin/header/header.component.html